import { isDebugEnabled } from './is-debug-enabled.fn';

// eslint-disable-next-line
export function consoleInfo(log: any) {
  if (isDebugEnabled()) {
    console.info(log);
  }
}
